import React, { useContext } from 'react';
import BookerShortContext from '../../context/bookerShortContext';
import RideInfo from '../Tracker/RideInfo';

const RideStatus = () => {
  const { ride, rideStatus } = useContext(BookerShortContext);

  if (!(ride && rideStatus !== 'enroute')) return <></>;
  return (
    <div className="info-container">
      <div id="ride-info">
        <RideInfo ride={ride} isGuestBooking={true} />
      </div>
    </div>
  );
};

export default RideStatus;
